<template>
    <div>
        <b-row>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <b-card class="sa-card sa-card-border" header="Esame Obiettivo Gen e Loc" header-tag="header" footer-tag="footer" title="">
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                            <span v-if="isReadOnly">{{ jsonDataEsameObiettivoGenLoc.voce }}</span>
                            <b-form-textarea v-else v-model="jsonDataEsameObiettivoGenLoc.voce" :readonly="isReadOnly" max-rows="10" rows="8"> </b-form-textarea>
                        </b-col>
                    </b-row>
                    <div class="d-flex justify-content-end">
                        <b-button v-if="!isReadOnly && jsonDataEsameObiettivoGenLoc.id" @click="onSaveEsameObiettivoGenLoc"  variant="outline-success">Salva</b-button>
                    </div>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";

export default {
    props: {
        isReadOnly: {
            type: Boolean,
            default: false,
        },
        idAccettazione: {
            type: String,
        },
        jsonDataEsameObiettivoGenLoc: {
            type: Object,
            default: function () {
                return {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    voce: "",
                };
            },
        },
    },
    mixins: [UtilityMixin],
    watch: {
        jsonDataEsameObiettivoGenLoc: {
            handler(jsonData) {
                this.$emit("update", jsonData);
            },
            deep: true,
        },
    },
    data() {
        return {
            pathResourceSchedaRelazioneSanitariaEsameObiettivoGenLoc: "/rsaschedarelazionesanitariaesameobiettivogenlocale",
        };
    },
    methods: {
        loadSchedaRelazioneSanitariaEsameObiettivoGenLoc() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceSchedaRelazioneSanitariaEsameObiettivoGenLoc + "/accettazione/" + me.idAccettazione, {}, me.resultResponseSchedaRelazioneSanitariaEsameObiettivoGenLocSuccess, me.resultResponseSchedaRelazioneSanitariaEsameObiettivoGenLocError);
        },

        resultResponseSchedaRelazioneSanitariaEsameObiettivoGenLocSuccess(response) {
            let me = this;
            me.jsonDataEsameObiettivoGenLoc = response.data.data;
        },

        resultResponseSchedaRelazioneSanitariaEsameObiettivoGenLocError(error) {
            let me = this;
            if (error.response && error.response.status === 404) {
                me.resetForm();
            }
        },

        resetForm() {
            let me = this;
            me.jsonDataEsameObiettivoGenLoc = {
                id: null,
                idAccettazione: me.idAccettazione,
                voce: null,
            };
        },

        onSaveEsameObiettivoGenLoc() {
            let me = this;
            me.jsonDataEsameObiettivoGenLoc.idAccettazione = me.idAccettazione;
            if (!me.jsonDataEsameObiettivoGenLoc.idAccettazione) {
                me.$bvToast.toast("Errore: ID Accettazione mancante", {
                    title: "Errore",
                    variant: "danger",
                    solid: true,
                });
                return;
            }
            UtilityMixin.methods.saveResource(me.pathResourceSchedaRelazioneSanitariaEsameObiettivoGenLoc, me.jsonDataEsameObiettivoGenLoc, me.saveSchedaRelazioneSanitariaEsameObiettivoGenLocSuccessResponse, me.saveSchedaRelazioneSanitariaEsameObiettivoGenLocErrorResponse);
        },
        saveSchedaRelazioneSanitariaEsameObiettivoGenLocSuccessResponse() {
            let me = this;
            me.$bvToast.toast("Esame obiettivo gen e loc salvato con successo", {
                title: "Successo",
                variant: "success",
                solid: true,
            });
            me.$parent.loadData();
        },
        saveSchedaRelazioneSanitariaEsameObiettivoGenLocErrorResponse() {
            console.error("Errore nel salvataggio esame obiettivo gen e loc:");
        },
    },
};
</script>
